<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Share and Save Coupon Listing</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'couponcode' ||
                          item.field.id == 'remitter_id')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="'Enter ' + item.field.name"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <!-- displayed FIlters -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for Date -->
                <template v-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Share and Save Coupon Listing -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const moment = require("moment");
export default {
  name: "ShareSaveCouponListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
  },
  data() {
    return {
      items: [
        {
          coupon_code: "WELCOME",
          start_date: "2024-05-16",
          end_date: "2024-05-20",
          coupon_used: 0,
          status: { name: "Expired", class: "badge-danger" },
          remitter_id: "10409",
        },
        {
          coupon_code: "FREE50",
          start_date: "2024-04-04",
          end_date: "2024-04-10",
          coupon_used: 1,
          status: { name: "Valid", class: "badge-info" },
          remitter_id: "	10336",
        },
        {
          coupon_code: "HELLO150",
          start_date: "2023-11-16",
          end_date: "2023-11-29",
          coupon_used: 1,
          status: { name: "Valid", class: "badge-info" },
          remitter_id: "10001",
        },
        {
          coupon_code: "WELCOME",
          start_date: "2022-08-15",
          end_date: "2022-08-25",
          coupon_used: 1,
          status: { name: "Expired", class: "badge-danger" },
          remitter_id: "10001",
        },
        {
          coupon_code: "TRY200",
          start_date: "2022-11-16",
          end_date: "2022-11-16",
          coupon_used: 0,
          status: { name: "Expired", class: "badge-danger" },
          remitter_id: "10082",
        },
      ],

      fields: [
        {
          key: "coupon_code",
          label: "Coupon Code",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "start_date",
          label: "Start date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "end_date",
          label: "End date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "coupon_used",
          label: "Coupon Used",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "remitter_id",
          label: "Remitter Id",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thClass: "th_sortfix",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      isVisibleFilter: false,
      displayFilters: [],
      statusoption: [
        { name: "Active", class: "badge-info" },
        { name: "Approve", class: "badge-success" },
        { name: "Reject", class: "badge-danger" },
        { name: "Inactive", class: "badge-warning" },
      ],
      filterField: [
        { id: "couponcode", name: "Coupon Code", $isDisabled: false },
        { id: "date", name: "Date", $isDisabled: false },
        { id: "remitter_id", name: "Remitter Id", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "couponcode", name: "Coupon Code", $isDisabled: false },
          search: "",
          date: {
            from: "",
            to: "",
          },
        },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    // for openFilters
    openFilters() {
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: {
              id: "couponcode",
              name: "Coupon Code",
              $isDisabled: false,
            },
            search: "",
            date: {
              from: "",
              to: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // apply filter
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (item.field.id == "couponcode" || item.field.id == "remitter_id") {
          data.filter_value = item.search;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("share-save-coupon-filter", params);
      this.displayFilters = this.$cookies.get("share-save-coupon-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "couponcode", name: "Coupon Code", $isDisabled: false },
          search: "",
          date: {
            from: "",
            to: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("share-save-coupon-filter", this.displayFilters);
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          date: {
            from: "",
            to: "",
          },
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("share-save-coupon-filter", this.displayFilters);
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("share-save-coupon-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters = this.$cookies.get("share-save-coupon-filter");
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (
            item.filter_field == "couponcode" ||
            item.filter_field == "remitter_id"
          ) {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: item.filter_value,
              date: {
                from: "",
                to: "",
              },
            });
          }
          if (item.filter_field == "date") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              date: {
                from: item.filter_value.from,
                to: item.filter_value.to,
              },
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    setTimeout(() => {
      this.cookieFilters();
    }, 1000);
  },
};
</script>
